import React, {Component} from 'react'
import {Form, FormGroup, Row, Col, Input, Button} from 'reactstrap'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import upsertClientContactsMutation from "../../../queries/server/mutations/upsert_client_contacts";
import editClientLocalMutation from "../../../queries/client_side/mutations/edit_client";

export default class ClientContactForm extends Component {

    state = {
        first_name: '',
        last_name: '',
        position: '',
        landline: '',
        mobile: '',
        email: ''
    }

    onChange = (({key, value}) => {
        const newData = {}
        newData[key] = value
        this.setState(newData)
    })

    render() {

        const {
            first_name,
            last_name,
            position,
            landline,
            mobile,
            email
        } = this.state

        const {onSave, onCancel, client_id} = this.props

        const {onChange} = this

        return (
            <Mutation mutation={upsertClientContactsMutation}>
                {(upsertClientContactsMutationFunc, {loading}) => (
                    <Mutation mutation={editClientLocalMutation}>
                        {(editClientLocalMutationFunc) => (
                            <Form>
                                <Row form className="mb-2">
                                    <Col>
                                        <Input
                                            size="sm"
                                            placeholder="First Name"
                                            value={first_name}
                                            onChange={(evt) => onChange({key: 'first_name', value: evt.target.value})}
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            size="sm"
                                            placeholder="Last Name"
                                            value={last_name}
                                            onChange={(evt) => onChange({key: 'last_name', value: evt.target.value})}
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            size="sm"
                                            placeholder="Position"
                                            value={position}
                                            onChange={(evt) => onChange({key: 'position', value: evt.target.value})}
                                        />
                                    </Col>
                                </Row>
                                <Row form className="mb-2">
                                    <Col>
                                        <Input
                                            size="sm"
                                            placeholder="Landline"
                                            value={landline}
                                            onChange={(evt) => onChange({key: 'landline', value: evt.target.value})}
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            size="sm"
                                            placeholder="Mobile"
                                            value={mobile}
                                            onChange={(evt) => onChange({key: 'mobile', value: evt.target.value})}
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            size="sm"
                                            type="email"
                                            placeholder="Email"
                                            value={email}
                                            onChange={(evt) => onChange({key: 'email', value: evt.target.value})}
                                        />
                                    </Col>
                                </Row>
                                <Row form className="mb-2">
                                    <Col>
                                        <Button
                                            size="sm"
                                            color="secondary"
                                            block
                                            onClick={onCancel}
                                        >
                                            <FontAwesomeIcon color="#fff" icon="times"/>{' '}
                                            Cancel
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button
                                            size="sm"
                                            color="success"
                                            block
                                            onClick={() => {
                                                upsertClientContactsMutationFunc({
                                                    variables: {
                                                        client_id, data: [{
                                                            first_name,
                                                            last_name,
                                                            position,
                                                            //landline,
                                                            //mobile,
                                                            //email
                                                        }]
                                                    }
                                                })
                                                    .then(({data}) => {
                                                        editClientLocalMutationFunc({variables: {data: data.upsertClientContact}})
                                                    })
                                            }}
                                            disabled={loading}
                                        >
                                            <FontAwesomeIcon color="#fff" icon={loading ? 'spinner': 'plus'}/>{' '}
                                            {loading ? 'Saving...' : 'Save Contact'}
                                        </Button>
                                    </Col>
                                </Row>

                            </Form>)}
                    </Mutation>)}
            </Mutation>

        )
    }

}

ClientContactForm.propTypes = {
    client_id: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}